enum BulkPriceReference {
    CurrentPrice,
    LowestPrice
}

export default BulkPriceReference;
